export var UpdateAccountTypeIA = function UpdateAccountTypeIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UPDATE_ACCOUNT_TYPE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [PLEASE_SEND_US_THE_FOLLOWING_INFO(strictLocalize), FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize), SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize), ONCE_WE_RECEIVE_THIS_INFO(strictLocalize)];
    }
  };
};
var UPDATE_ACCOUNT_TYPE = function UPDATE_ACCOUNT_TYPE(strictLocalize) {
  return strictLocalize({
    id: "QzoC6y",
    defaultMessage: [{
      "type": 0,
      "value": "Définir « Boutique physique » comme type de compte"
    }]
  });
};
var PLEASE_SEND_US_THE_FOLLOWING_INFO = function PLEASE_SEND_US_THE_FOLLOWING_INFO(strictLocalize) {
  return strictLocalize({
    id: "oR9T2X",
    defaultMessage: [{
      "type": 0,
      "value": "Pour commencer, envoyez-nous les informations suivantes par l'un des moyens de contact renseignés dans la section « Nous contacter » :"
    }]
  });
};
var FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE = function FIRST_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize) {
  return strictLocalize({
    id: "rAF0hs",
    defaultMessage: [{
      "type": 0,
      "value": "1. L'adresse physique de votre boutique"
    }]
  });
};
var SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE = function SECOND_STEP_TO_UPDATE_ACCOUNT_TYPE(strictLocalize) {
  return strictLocalize({
    id: "MvxnaR",
    defaultMessage: [{
      "type": 0,
      "value": "2. Photos de l'intérieur et de l'extérieur de votre boutique avec votre enseigne visible sur les photos prises de l'extérieur"
    }]
  });
};
var ONCE_WE_RECEIVE_THIS_INFO = function ONCE_WE_RECEIVE_THIS_INFO(strictLocalize) {
  return strictLocalize({
    id: "ElLq0T",
    defaultMessage: [{
      "type": 0,
      "value": "Lorsque nous aurons reçu ces informations, notre équipe d'assistance se fera un plaisir de mettre à jour votre type de compte ou de répondre à toute question que nous pourrions avoir à votre sujet."
    }]
  });
};